import script from "./reportJdwzzw.vue?vue&type=script&setup=true&lang=js"
export * from "./reportJdwzzw.vue?vue&type=script&setup=true&lang=js"

import "./reportJdwzzw.vue?vue&type=style&index=0&id=1fb46af6&lang=less"

const __exports__ = script;

export default __exports__